module.exports = __webpack_public_path__ + "img/fallprotection.475292ae.png";